import { render, staticRenderFns } from "./CollapsableCard.vue?vue&type=template&id=0a2ba08c&scoped=true"
import script from "./CollapsableCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./CollapsableCard.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CollapsableCard.vue?vue&type=style&index=0&id=0a2ba08c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2ba08c",
  null
  
)

export default component.exports